import { RootState, setExternalUserId, setGuestUserId } from "@next-platform/client-common-core";
import { AnyAction, Dispatch, MiddlewareAPI } from "@reduxjs/toolkit";

import { GUEST_USER_ID_KEY } from "@/constants";
import jsonApiService from "@/services/jsonApiService";
import { typedLocalStorageService } from "@/utils/localStorageRe";

export const userMiddleware = (store: MiddlewareAPI<Dispatch, RootState>) => (next: Dispatch) => async (action: AnyAction) => {
  action = next(action);

  //Persist the guest user id in local storage
  const state = store.getState();
  if (setGuestUserId?.match(action)) {
    jsonApiService.setGuestUserId(state.userInfo.guestUserId);
    typedLocalStorageService.setGuestUserId(state.userInfo.guestUserId as string);
    localStorage.setItem(GUEST_USER_ID_KEY, state.userInfo.guestUserId as string);
  }

  // Allows for the intermediate step of 3rd party receiving on onboarding token for user creation only
  if (setExternalUserId.match(action)) {
    jsonApiService.setExternalUserId(state.userInfo.externalUserId);
  }

  return action;
};
